<template>
    <v-card
            class="mx-auto"
            max-width="500"
    >
        <v-alert
                v-if="alert.show"
                :type="alert.type"
                border="left"
        >
            {{alert.text}}
        </v-alert>
        <v-card-title class="title font-weight-regular justify-space-between">
            <span>{{ currentTitle }}</span>

            <v-avatar
                    color="primary lighten-2"
                    class="subheading white--text"
                    size="24"
                    v-text="step"
            ></v-avatar>

            <v-progress-linear
                    :active="loading"
                    indeterminate
                    rounded
            ></v-progress-linear>

        </v-card-title>

        <v-window v-model="step">

            <v-window-item :value="1">
                <v-card-text>
                    <v-text-field
                            v-model="form.nome"
                            autofocus
                            placeholder="digite o nome do novo usuário"
                    ></v-text-field>
                    <span class="caption grey--text text--darken-1">
                        Nome do usuário
                    </span>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="2">
                <v-card-text>
                    <v-text-field
                            v-model="form.email"
                            autofocus
                            ref="email"
                            placeholder="digite o email q será utilizado na nova conta"
                    ></v-text-field>
                    <span class="caption grey--text text--darken-1">
                        Este é o email que será usado para logar no digitab
                    </span>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="3">
                <div class="pa-4 text-center">
                    <h3 class="title font-weight-light mb-2">Digitab</h3>
                    <span class="caption grey--text">Mídia interna</span>

                    <div
                            v-if="codAtivacao"
                    >
                        <v-divider></v-divider>
                        <span>Link de ativação:</span>
                        <v-spacer></v-spacer>
                        <span class="caption">
                            {{$store.state.domain}}/user/activate?email={{form.email}}&token={{codAtivacao}}
                        </span>
                    </div>
                </div>
            </v-window-item>
        </v-window>

        <v-divider v-if="step <= 2"></v-divider>

        <v-card-actions>
            <v-btn
                    v-if="step <= 2"
                    :disabled="step === 1"
                    text
                    @click="step--"
            >
                Voltar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                    v-if="step <= 2"
                    color="primary"
                    depressed
                    @click="step++"
            >
                Continuar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>


<script>
    export default {
        data: () => ({
            form: {
                nome: '',
                email: '',
            },
            alert: {
                type: '',
                show: '',
                text: '',
            },
            codAtivacao: null,
            loading: false,
            step: 1,
        }),

        computed: {
            currentTitle() {
                switch (this.step) {
                    case 1:
                        return 'Nome'
                    case 2:
                        return 'Email'
                    default:
                        return 'Criando usuário'
                }
            },
        },

        watch: {
            step: {
                handler() {
                    if (this.step === 2 && this.form.nome == '') {
                        alert('O nome é obrigatório');
                        this.step = 1;
                    }

                    if (this.step === 3 && this.form.email == '') {
                        alert('O email é obrigatório');
                        this.step = 2;

                        return;
                    }

                    if (this.step === 3) {
                        this.save();
                    }
                },
            }
        },

        methods: {
            save() {
                this.loading = true;

                axios.post('/usuarios',
                    this.form
                ).then((response) => {
                    this.alert.type = 'success';
                    this.alert.show = true;
                    this.alert.text = 'Usuário criado';
                    this.codAtivacao = response.data.codigo_ativacao;
                }, (error) => {
                    this.alert.type = 'warning';
                    this.alert.show = true;
                    this.alert.text = error.response.data.msg;
                }).catch(error => {
                    console.log(error)
                    this.alert.type = 'error';
                    this.alert.show = true;
                    this.alert.text = 'Houve algum erro ao salvar o registro.';
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>
